import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import request from "../../utils/request";
import "./style.css";
import { LoadingButton } from "../loadingButton";

export const DeleteModal = ({
  openDeleteModal,
  onClose,
  endPoint,
  title,
  refetchApi,
}) => {
  const [loading, setLoading] = useState(false);

  const deleteEntity = async () => {
    setLoading(true);
    const response = await request.delete(endPoint);
    if (response) {
      onClose();
      refetchApi();
    }
    setLoading(false);
  };

  return (
    <div>
      <Modal open={openDeleteModal} onClose={onClose} center>
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-illustration">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64"
                fill="white"
              >
                <path d="M50.4 16.4C48.7 14.7 46.4 14 44 14H20c-2.4 0-4.7.7-6.4 2.4L6.4 22.5C4.7 24.2 4 26.5 4 28.9v14.2c0 4.7 3.8 8.5 8.5 8.5h38.9c4.7 0 8.5-3.8 8.5-8.5V28.9c0-2.4-.7-4.7-2.4-6.4l-7.1-6.1zM34 44h-4v-4h4v4zm0-8h-4V22h4v14z" />
                <circle cx={32} cy={54} r={6} fill="white" />
              </svg>
            </div>
            <div className="modal-body">
              <h3 className="mb-3 mt-3">Delete Confirmation</h3>
              <p className="text-muted">
                Are you sure you want to delete this item?
              </p>
              <p class="small text-danger">{title}</p>
            </div>
            <div className="modal-footer">
              <LoadingButton
                isLoading={loading}
                buttonText={"Delete"}
                customClass={"btn btn-primary create-btn mt-3 mb-3 mr-2"}
                onClick={() => deleteEntity()}
                iconType="bi-trash"
              />
              &nbsp;&nbsp;&nbsp;
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
